import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind utilities beat earlier ones.
 *
 * The app's own `@/lib/utils` re-exports THIS one rather than keeping a second
 * copy: two `cn`s with independently-updated `tailwind-merge` versions resolve
 * conflicting utilities differently, and a component that renders correctly in
 * `apps/web` and wrongly in a package is the worst kind of drift to chase.
 * Date helpers stay in the app — they are domain, not presentation.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
